module.exports = __webpack_public_path__ + "static/media/be.6d44f4d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/be.svg
// module id = 61
// module chunks = 0